@if (projectQuestionnaires().length) {

<div class="card">
    <div class="card-body">
        <select class="form-select" [(ngModel)]="selectedQuestionnaire">
            @for (questionnaire of projectQuestionnaires(); track questionnaire.id) {
            <option [value]="questionnaire.id">{{questionnaire.date_edited | date:dateFormat()}}</option>
            }
        </select>
        <div class="m-3">
            @let selected = selectedQuestion();

            @if (selected) {
            @for (sub of selected.subquestions; track sub.id) {
            <h3 class="fs-6">{{sub.content}}</h3>
            <p>
                <em>{{sub?.answer?.content || '-'}}</em>
            </p>
            }
            }
        </div>
        <button type="button" class="btn btn-secondary" (click)="emitCopyQuestion()">
            <fa-icon [icon]="faAnglesLeft" aria-hidden="true" />
            Overnemen
        </button>
    </div>
</div>
}
